import { render, staticRenderFns } from "./OrderNotification.vue?vue&type=template&id=ed10d138&"
import script from "./OrderNotification.vue?vue&type=script&lang=js&"
export * from "./OrderNotification.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotification.vue?vue&type=style&index=0&id=ed10d138&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports